import React, { useEffect } from 'react';
import './App.css';
import { Toaster } from './components/ui/sonner';
import Header from './components/Header';
import Hero from './components/Hero';
import Products from './components/Products';
import Benefits from './components/Benefits';
import UseCases from './components/UseCases';
import HowItWorks from './components/HowItWorks';
import MobileApp from './components/MobileApp';
import Locations from './components/Locations';
import Pricing from './components/Pricing';
import Partner from './components/Partner';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const headerOffset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    } else {
      // If section doesn't have an ID, scroll to top for hero
      if (sectionId === 'hero') {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    }
  };

  useEffect(() => {
    // Smooth scroll behavior
    document.documentElement.style.scrollBehavior = 'smooth';
  }, []);

  return (
    <div className="App min-h-screen bg-white">
      <Header onNavigate={scrollToSection} />
      <main>
        <div id="hero">
          <Hero onNavigate={scrollToSection} />
        </div>
        <Products />
        <Benefits />
        <UseCases />
        <HowItWorks />
        <MobileApp onNavigate={scrollToSection} />
        <Locations />
        <Pricing onNavigate={scrollToSection} />
        <Partner onNavigate={scrollToSection} />
        <FAQ />
        <Contact />
      </main>
      <Footer onNavigate={scrollToSection} />
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
